window.Password = window.Password || {};
Password.Validator = Password.Validator || {};
Password.Validator.NuevaClave = Password.Validator.NuevaClave || {};

Password.Validator.Variacion = Password.Validator.Variacion || {};
Password.Validator.Variacion.Digit = false;
Password.Validator.Variacion.Lower = false;
Password.Validator.Variacion.Upper = false;
Password.Validator.Variacion.NonWords = false;

Password.Validator.PassComplex = "weak";

Password.Validator.RepetirClave = false;	// Valor para ver si tengo que validar repetición de clave
Password.Validator.ActualClave = false; 	// Valor para ver si tengo que validar el ingreso de la clave actual
Password.Validator.NuevaClave = false; 	// Valor para ver si tengo que validar el ingreso de la nueva clave
Password.Validator.Captcha = false; 	    // Valor para ver si tengo que validar el ingreso del captcha

Password.Validator.submitActive = true;


Password.Validator.STR_PASS_DIFERENTES = "Las contraseñas no coinciden. Por favor, ingresalas nuevamente";
Password.Validator.STR_PASS_ACTUAL_VACIA = "Debe ingresar la clave actual";
Password.Validator.STR_PASS_ACTUAL_REPETIDA = "La nueva clave no debe ser la misma que la clave actual";
Password.Validator.STR_PASS_CANT_CARACTERES = "La contraseña tiene que tener al menos 8 caracteres";
Password.Validator.STR_NO_CAPTCHA = "Debés ingresar el captcha";
Password.Validator.STR_PASS_VACIO = "El campo no puede estar vacío";
Password.Validator.STR_PASS_NUEVA_VACIO = "Por favor, confirmá la contraseña";

Password.Validator.STR_PASS_FLAG_ROJO = "Contraseña insegura. Evitá repetición de números y caracteres";
Password.Validator.STR_PASS_FLAG_AMARILLO = "Contraseña poco segura";
Password.Validator.STR_PASS_FLAG_VERDE = "Contraseña válida";




Password.Validator.scorePassword = function (pass) {
    var score = 0;

    if (!pass || pass.length < 8)	// Si no hay pass o si es menor a 8 caracteres score = 0 
        return score;

    var letters = new Object();
    for (var i = 0; i < pass.length; i++) {
        letters[pass[i]] = (letters[pass[i]] || 0) + 1;
        score += 5.0 / letters[pass[i]];
    }

    Password.Validator.Variacion.Digit = /\d/.test(pass);
    Password.Validator.Variacion.Lower = /[a-z]/.test(pass);
    Password.Validator.Variacion.Upper = /[A-Z]/.test(pass);
    Password.Validator.Variacion.NonWords = /\W/.test(pass);
    Password.Validator.Variacion.LowerAndUpper = /[a-zA-Z]/.test(pass);

    var variationCount = 0;
    for (var check in Password.Validator.Variacion) {
        variationCount += (Password.Validator.Variacion[check] == true) ? 1 : 0;
    }
    score += (variationCount - 1) * 10;

    // Valido que se hayan "activado" las variaciones obligatorias, sino devuelvo score = 0 
    if (Password.Validator.Variacion.Digit && Password.Validator.Variacion.LowerAndUpper /*&& Password.Validator.Variacion.Lower && Password.Validator.Variacion.Upper*/) return parseInt(score);
    else return 0;
}

Password.Validator.checkPassStrength = function (pass) {
    var score = Password.Validator.scorePassword(pass);

    if (score > 80)
        Password.Validator.PassComplex = "strong";
    else if (score >= 55)
        Password.Validator.PassComplex = "strong";
    else if (score < 55)
        Password.Validator.PassComplex = "weak";

    (score < 55) ? Password.Validator.submitActive = false : Password.Validator.submitActive = true;

    return Password.Validator.PassComplex;

}

Password.Validator.MostrarTextoErrorPassword = function () {
    var variationCount = 0;
    var stringError = "";

    if ($(".val-nueva-clave").val().length < 8) {
        stringError = Password.Validator.STR_PASS_CANT_CARACTERES;
        $(".val-nueva-clave-mensaje").html(stringError).addClass("error")
                    .removeClass("check");

    } else {
        // Cuento las variaciones que estÃ¡n activas . Tienen que ser 3 en total porque no cuento la de sÃ­mbolos "NonWords" . 
        for (var check in Password.Validator.Variacion) {
            variationCount += (Password.Validator.Variacion[check] == true && check != "NonWords") ? 1 : 0;
            //variationCount += (Password.Validator.Variacion[check] == true) ? 1 : 0;
        }

        if (variationCount < 3) {
            var i = 0;
            for (var check in Password.Validator.Variacion) {
                if (Password.Validator.Variacion[check] != true && check != "NonWords") {
                    //if (Password.Validator.Variacion[check] != true) {
                    i++;

                    if (check == "Digit") {
                        stringError += "Tenés que incluir un número";
                    } else if (check == "LowerAndUpper") {
                        stringError += "Tenés que incluir al menos una letra.";
                    }

                   
                }
            }

            $(".val-nueva-clave-mensaje").show();
        }
    }

    // Muestro mensaje de clave correspondiente a la complejidad de la clave
    switch (Password.Validator.PassComplex) {
        case "weak":

            $(".val-guardar").prop("disabled", true).addClass("btn-inactivo");	// Desactivo botón submit
            $(".val-nueva-clave").parent().addClass("error").removeClass("check");	// Agrego flag rojo

            if (stringError != "") stringError = stringError;   // Si la clave no cumple los requerimientos mÃ­nimos
            else stringError = Password.Validator.STR_PASS_FLAG_ROJO; // La clave cumple los requerimientos mÃ­nimos pero no pondera lo suficiente 

            $(".val-nueva-clave-mensaje").html(stringError)
                                                .addClass("error")
                                                .removeClass("check");

            break;

            //case "good":
            //    $(".val-guardar").prop("disabled", false).removeClass("btn-inactivo");	// Habilito botón submit
            //    $(".val-nueva-clave").addClass("pass-amarillo").removeClass("pass-verde").removeClass("pass-rojo");	// Agrego flag amarillo
            //    $(".val-nueva-clave-mensaje").html(Password.Validator.STR_PASS_FLAG_AMARILLO)
            //        .addClass("mensaje-contrasena-amarillo")
            //        .removeClass("mensaje-contrasena-rojo")
            //        .removeClass("mensaje-contrasena-verde");// Texto flag amarillo
            //    break;

        case "strong":
            $(".val-guardar").prop("disabled", false).removeClass("btn-inactivo");	// Habilito botón submit
            $(".val-nueva-clave").parent().addClass("check").removeClass("error");	// Agrego flag verde
            $(".val-nueva-clave-mensaje").html(Password.Validator.STR_PASS_FLAG_VERDE)
                .addClass("check")
                .removeClass("error");	// Texto flag verde
            break;
    }
}

Password.Validator.canSubmit = function (validateCaptchaNow) {
    var nuevaClave = $(".val-nueva-clave").val();
    var repetirClave = $(".val-repetir-clave").val();
    var actualClave = $(".val-actual-clave").val();

    var canSubmit = true;

    // Limpio los errores y sus mensajes en los span 
    $(".error").each(function (item, value) {
        $(value).removeClass("error");
        $(value).find("span").html("");
    });

    if (Password.Validator.ActualClave) {	// Si está el input de clave actual
        if (actualClave == "") {	// Valido que la clave actua sea diferente de vacío
            $(".val-actual-clave-mensaje").html(Password.Validator.STR_PASS_ACTUAL_VACIA);
            $(".val-actual-clave").parent().addClass("error").removeClass("check");
            return false;
        } else if (actualClave == nuevaClave) {
            $(".val-actual-clave-mensaje").html(Password.Validator.STR_PASS_ACTUAL_REPETIDA);
            $(".val-actual-clave").parent().addClass("error").removeClass("check");
            return false;
        }
    }

    if (Password.Validator.RepetirClave) {	// Si está el input de repetir clave
        if (nuevaClave == "") {
            $(".val-nueva-clave-mensaje").html(Password.Validator.STR_PASS_VACIO);
            $(".val-nueva-clave").parent().addClass("error").removeClass("check");

            $(".val-repetir-clave-mensaje").html(Password.Validator.STR_PASS_NUEVA_VACIO);
            $(".val-repetir-clave").parent().addClass("error").removeClass("check");
            return false;
        } else if (Password.Validator.checkPassStrength($(".val-nueva-clave").val()) == "weak") {
            Password.Validator.MostrarTextoErrorPassword();            
        }

        if (repetirClave == "") {
            $(".val-repetir-clave-mensaje").html(Password.Validator.STR_PASS_NUEVA_VACIO);
            $(".val-repetir-clave").parent().addClass("error").removeClass("check");
            return false;
        }

        if (nuevaClave != repetirClave) {	// Valido que la clave nueva sea igual a repetir clave
            $(".val-repetir-clave-mensaje").html(Password.Validator.STR_PASS_DIFERENTES);
            $(".val-repetir-clave").parent().addClass("error").removeClass("check");
            return false;
        }
    }

    if (Password.Validator.NuevaClave) { // Si está el input de nueva clave
        if (nuevaClave == "") {
            $(".val-nueva-clave-mensaje").html(Password.Validator.STR_PASS_VACIO);
            $(".val-nueva-clave").parent().addClass("error").removeClass("check");

            //$(".val-repetir-clave-mensaje").html(Password.Validator.STR_PASS_VACIO);
            //$(".val-repetir-clave").parent().addClass("error").removeClass("check");
            return false;
        } else if (Password.Validator.checkPassStrength($(".val-nueva-clave").val()) == "weak") {
            Password.Validator.MostrarTextoErrorPassword();
            return false;
        }

    }

    if (validateCaptchaNow) {
        if (Password.Validator.Captcha) {
            if ($("#g-recaptcha-response").val() == "") {
                $("#recaptcha-mensaje").html(Password.Validator.STR_NO_CAPTCHA);
                return false;
            }
        }
    }

    // Validaciones de que la clave nueva esté . (los mensaje de error ya se mostraron anteriormente)
    if (nuevaClave == undefined || nuevaClave == null || nuevaClave == "") {
        return false;
    }

    return true;
}


$.fn.strongpass = function (callback) {
    // Iterate all elements the selector applies to
    this.each(function () {
        var $input = $(this);
        // Can probably make this more obvious by using "is"
        if ($input.is("input")) {
            // Chequeo si existe campo repetir-clave 
            if ($(".val-repetir-clave").length > 0) Password.Validator.RepetirClave = true;

            // Chequeo si existe campo actual-clave
            if ($(".val-actual-clave").length > 0) Password.Validator.ActualClave = true;

            // Chequeo si existe campo actual-clave
            if ($(".val-nueva-clave").length > 0) Password.Validator.NuevaClave = true;

            // Chequeo si existe el captcha
            if ($("#recaptcha_area").length > 0 || $(".g-recaptcha").length > 0) Password.Validator.Captcha = true;

            $(".val-guardar").prop("disabled", true).addClass("btn-inactivo");

            // Muestro los mensajes correspondientes a la validación 
            //Password.Validator.MostrarTextoErrorPassword();

            // Now bind to the keyup event of this individual input
            $input.on("keyup", function () {
                var input_str = $.trim($input.val());

                // Seteo variables de dificultad de password
                Password.Validator.checkPassStrength(input_str);

                // Muestro los mensajes correspondientes a la validación 
                Password.Validator.MostrarTextoErrorPassword();
            });

            var canSubmitfnc = Password.Validator.canSubmit;

            $input.on("focusout", function () {
                canSubmitfnc(false);
            });

            if (Password.Validator.RepetirClave) {
                $(".val-repetir-clave").on("focusout", function () {
                    canSubmitfnc(false);
                });
            }

            if (Password.Validator.ActualClave) {
                $(".val-actual-clave").on("focusout", function () {
                    canSubmitfnc(false);
                });
            }

            if (Password.Validator.NuevaClave) {
                $(".val-nueva-clave").on("focusout", function () {
                    canSubmitfnc(false);
                });
            }
        }
    });
};


// WEBPACK FOOTER //
// ./Statics/scripts/login/core/validar-clave-lib.js